var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12363_45435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2891 8.37L19.2891 6.64C19.0091 6.16 18.3991 6 17.9191 6.27L13.9991 8.54V4C13.9991 3.45 13.5491 3 12.9991 3H10.9991C10.4491 3 9.99914 3.45 9.99914 4V8.54L6.06914 6.27C5.58914 5.99 4.97914 6.16 4.70914 6.63L3.70914 8.36C3.42914 8.84 3.58914 9.46 4.06914 9.73L7.99914 12L4.06914 14.27C3.58914 14.55 3.42914 15.16 3.69914 15.64L4.69914 17.37C4.97914 17.85 5.58914 18.01 6.06914 17.74L9.99914 15.46V20C9.99914 20.55 10.4491 21 10.9991 21H12.9991C13.5491 21 13.9991 20.55 13.9991 20V15.46L17.9291 17.73C18.4091 18.01 19.0191 17.84 19.2991 17.36L20.2991 15.63C20.5791 15.15 20.4091 14.54 19.9291 14.26L15.9991 12L19.9291 9.73C20.4091 9.46 20.5691 8.84 20.2891 8.37Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12363_45435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.e01fb792508689e91e8dfeece50640dc.svg";
export { ForwardRef as ReactComponent };